import { BaseAPI } from './generated/base';
import { Configuration } from './generated';
import globalAxios, { AxiosInstance } from 'axios';
import { getProgramId } from '../utils/programs';

export enum ProxyApiType {
    STAC = 'stac',
    /** NOTE: Currently only for tasking orders */
    ORDERS = 'orders',
}

/**
 * StacApi - object-oriented interface
 * @export
 * @class StacApi
 * @extends {BaseAPI}
 */
export class ProxyAPI extends BaseAPI {
    constructor(apiType: ProxyApiType, configuration?: Configuration, protected axios: AxiosInstance = globalAxios) {
        super(configuration, undefined, axios);

        if (configuration) {
            this.configuration = configuration;

            const programId = getProgramId();

            if (programId > 0) {
                this.basePath = `${configuration.basePath}/${apiType}/programs/${programId}`;
            }
        }
    }
}
